import { defineAgenda, param } from '@/shared/navigation/core';
// Přímo z modelu (ne přes barrel `./calendar`): definice agendy nemá tahat strom komponent
// kalendáře — registr agend ji importuje dřív než jejich komponenty.
import { monthCodec } from './calendar/overview/calendarModel';

export const venuaPlannerAgenda = defineAgenda({
  id: 'app.venua-planner',
  path: 'app/venua-planner',
  open: {},
  state: {
    activeNodeId: param.uuid().optional(),
    transportType: param.enum(['Air', 'Bus'] as const).optional(),
    includeHistory: param.boolean().optional(),
    /** Měsíc kalendáře ('YYYY-MM') — deep-link i obnova po reloadu. */
    month: param.custom(monthCodec).optional(),
    /** Termín otevřený v draweru kalendáře. */
    termId: param.uuid().optional(),
    /** Osa kalendáře — týdny pod sebou (výchozí) nebo jedna souvislá řada dnů. */
    axis: param.enum(['weeks', 'timeline'] as const).optional(),
    /**
     * Čtení časů dopravy: `logical` (výchozí) kreslí spoj u termínu, ke kterému patří,
     * `real` ho posadí na dny, kdy skutečně jede (−1d / +1d přes dvě políčka).
     */
    timeMode: param.enum(['logical', 'real'] as const).optional(),
  },
  title: 'Planner',
  icon: 'folders-tree',
  presentationHints: {
    shell: {
      // Strom vlevo, detail vpravo. Detail zónu drží kalendář agendy (`DetailZoneOutlet`);
      // vrstva s `zone: 'detail'` (výběr ve stromu) ho překryje a po zavření je zase vidět.
      layoutMode: 'list-detail',
    },
  },
});
